import { Menu } from '@pocketlaw/tetris';
import { ColumnIcon } from './ColumnIcon';
import { ColumnToggle } from './ColumnToggle';
import { HiddenItemContainer } from './styled';
export function HiddenItem(props) {
    const { disabled, children, active, onToggle } = props;
    return (<HiddenItemContainer disabled={disabled} onClick={onToggle}>
      <ColumnIcon active={active}/>
      <Menu.ItemText primary={children}/>
      <ColumnToggle active={active} onClick={onToggle}/>
    </HiddenItemContainer>);
}
